// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "preferences-UbO2o";
var _5 = "title-18Ihf";
var _6 = "selects-2S8Sh";
var _7 = "label-37KRH";
var _8 = "focused-2BMjQ";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "preferences", _5 as "title", _6 as "selects", _7 as "label", _8 as "focused" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "preferences": _4, "title": _5, "selects": _6, "label": _7, "focused": _8 }
